import { availableSectionViews } from '../../runtime/platform/core.runtime.js';
import { setView } from '../../runtime/shell/navigation.runtime.js';

function openSection(section) {
  const first = availableSectionViews(section)[0]?.[0] || 'schedule';
  void setView(first);
}

export function Sidebar() {
  return (
      <aside class={"sidebar"}>
        <header class={"sidebar-head"}>
          <div class={"brand-lockup compact"}>
            <img class={"brand-symbol small"} src={"/assets/icon.svg"} alt={""} />
            <span class={"brand-wordmark compact"} aria-label={"kUni"}>
              {"kUn"}
              <span class={"brand-i"}>
                {"ı"}
              </span>
            </span>
          </div>
          <button class={"icon-button"} id={"theme-toggle"} type={"button"} data-ui-text-title={"shell.theme.toggle"} data-ui-text-aria={"shell.theme.toggle"}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M12 3a9 9 0 1 0 9 9c0-.4 0-.8-.1-1.2A7 7 0 0 1 12 3Z"}></path>
            </svg>
          </button>
        </header>
        <div class={"group-selector-wrap"}>
          <label for={"group-selector"} data-ui-text={"shell.group.current"}></label>
          <button class={"group-selector-button"} id={"group-selector"} type={"button"} aria-haspopup={"dialog"} aria-label={"Выбрать группу"}>
            <span class={"group-selector-copy"}>
              <strong data-current-group-short={""}>
                {"Группа не выбрана"}
              </strong>
              <small data-current-group-context={""}></small>
            </span>
            <span class={"group-selector-chevron"} aria-hidden={"true"}>
              {"⌄"}
            </span>
          </button>
        </div>
        <nav class={"nav nav-sections"} aria-label={"Разделы"}>
          <span class={"nav-label"} data-ui-text={"shell.nav.label"}></span>
          <button class={"nav-item section-nav-item active"} data-section={"today"} onClick={() => openSection('today')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"}></path>
            </svg>
            <span data-ui-text={"shell.nav.today"}></span>
          </button>
          <button class={"nav-item section-nav-item"} data-section={"study"} onClick={() => openSection('study')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M4 5h16v14H4zM8 9h8M8 13h5"}></path>
            </svg>
            <span data-ui-text={"shell.nav.study"}></span>
          </button>
          <button class={"nav-item section-nav-item"} data-section={"knowledge"} onClick={() => openSection('knowledge')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M4 5.5A3.5 3.5 0 0 1 7.5 2H20v17H7.5A3.5 3.5 0 0 0 4 22V5.5Z"}></path>
            </svg>
            <span data-ui-text={"shell.nav.knowledge"}></span>
          </button>
          <button class={"nav-item section-nav-item"} data-section={"campus"} onClick={() => openSection('campus')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"m9 18-6 3V6l6-3 6 3 6-3v15l-6 3-6-3Zm0 0V3m6 18V6"}></path>
            </svg>
            <span data-ui-text={"shell.nav.campus"}></span>
          </button>
          <button class={"nav-item section-nav-item"} data-section={"more"} onClick={() => openSection('more')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M5 12h.01M12 12h.01M19 12h.01"}></path>
            </svg>
            <span data-ui-text={"shell.nav.more"}></span>
            <b id={"notification-badge"} hidden></b>
          </button>
          <button class={"nav-item simple-nav-item"} data-simple-view={"home"} onClick={() => void setView('home')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M3 11.5 12 4l9 7.5M5.5 10v10h13V10M9 20v-6h6v6"}></path>
            </svg>
            <span data-ui-text={"shell.nav.home"}></span>
          </button>
          <button class={"nav-item simple-nav-item"} data-simple-view={"schedule"} onClick={() => void setView('schedule')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"}></path>
            </svg>
            <span data-ui-text={"shell.nav.schedule"}></span>
          </button>
          <button class={"nav-item simple-nav-item"} data-simple-view={"studyhub"} onClick={() => void setView('studyhub')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M4 5h16v14H4zM8 9h8M8 13h5"}></path>
            </svg>
            <span data-ui-text={"shell.nav.study"}></span>
          </button>
          <button class={"nav-item simple-nav-item"} data-simple-view={"morehub"} onClick={() => void setView('morehub')}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M5 12h.01M12 12h.01M19 12h.01"}></path>
            </svg>
            <span data-ui-text={"shell.nav.more"}></span>
          </button>
        </nav>
        <button class={"nav-item global-settings-item"} type={"button"} data-open-settings={""} onClick={() => void setView('settings')}>
          <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
            <circle cx={"12"} cy={"12"} r={"3"}></circle>
            <path d={"M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21h-4v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3v-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.5V3h4v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.1v4h-.1a1.7 1.7 0 0 0-1.5 1Z"}></path>
          </svg>
          <span data-ui-text={"shell.settings"}></span>
        </button>
        <footer class={"account-row"}>
          <div class={"avatar"} id={"avatar"}>
            {"k"}
          </div>
          <div class={"account-meta"}>
            <strong id={"account-name"} data-ui-text={"shell.account.student"}></strong>
            <span id={"account-email"}></span>
          </div>
          <button class={"icon-button"} id={"logout"} type={"button"} data-ui-text-title={"shell.logout"} data-ui-text-aria={"shell.logout"}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M10 17l5-5-5-5M15 12H3M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5"}></path>
            </svg>
          </button>
        </footer>
      </aside>
  );
}
